import './info.css';

const Info = () => {
    return (
        <>
        <div className="wrapper">
        <div className="infobox">
            <h3 className="headline">Thank you</h3>
            <p className="infoText">I am thrilled to display some of my work in this whitespace-format. I find it quite elegant, and it was a fun sunday project.
                If you do <i>do</i> want my photography services, please feel free to contact me.</p>
        </div>
        </div>
        </>
    )

}
export default Info;